import DocumentTreeView from './DocumentsView.vue';
import DocumentsHeader from './DocumentsHeaderOneRow.vue';
import moduleId from './moduleId';
export const ROUTE_NAMES = { documentsRoot: 'documentsRoot', documentFolder: 'documentFolder', documentFile: 'documentFile' };

class DocumentRouteHandler {
  getRoutes = ({ moduleType }) => {
    return [
      {
        path: '/documents/:instance',
        name: ROUTE_NAMES.documentsRoot,
        meta: { moduleType, initiateSyncBeforeNav: true, moduleId, baseRoute: true },
        // dynamic load with tree-shaking: However, pwa needs to handle this specific route
        // component: () => import('@/modules/document/index.vue'),
        // header: () => import('@/modules/document/header.vue'),
        //components: { default: DocumentTreeView, header: DocumentsHeader, topHeader: DocumentsTopHeader },
        // components: { default: () => import('./DocumentsView.vue'), header: () => import('./DocumentsHeaderOneRow.vue') },
        components: { default: DocumentTreeView, header: DocumentsHeader },
      },

      {
        path: '/documents/:instance/folder/:folderId',
        props: true,
        name: ROUTE_NAMES.documentFolder,
        meta: { moduleType, initiateSyncBeforeNav: false, moduleId, baseRoute: false },
        //components: { default: () => import('./DocumentsView.vue'), header: () => import('./DocumentsHeaderOneRow.vue') },
        components: { default: DocumentTreeView, header: DocumentsHeader },
      },

      {
        path: '/documents/:instance/:documentId',
        props: true,
        name: ROUTE_NAMES.documentFile,
        meta: { moduleType, initiateSyncBeforeNav: false, moduleId, baseRoute: false },
        //components: { default: () => import('./DocumentsView.vue'), header: () => import('./DocumentsHeaderOneRow.vue') },
        components: { default: DocumentTreeView, header: DocumentsHeader },
      },
    ];
  };
}
const routeHandler = new DocumentRouteHandler();
export default routeHandler;
